import { ProfileAdmin } from '../../components/_dashboard/profiles';


export default function Profile() {
    return (
        <ProfileAdmin />
    );
}
